<template>
    <div class="myhie-cta" v-if="items.length">
        <h2>Related topics</h2>

        <ul class="blog-tags layout">
            <li v-for="item in items" :key="item.Id">
                <a :href="item.Url">{{item.Title}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {

        created() {
            this.getItems()
        },

        data() {
            return {
                items: []
            }
        },

        methods: {
            getItems() {
                Axios.get('/umbraco/api/BlogApi/RelatedTopics', { params: { pageId: currentPageId} })
                    .then((response) => {
                        if (response.status == 200) {
                            this.items = response.data
                        }
                    })
            }
        }
    }
</script>